import React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { showWaste, generateMonthlyIncome } from '../../../store/actions/waste';

import { useFormik } from 'formik';
import { validation, formValues } from './validationSchema';
import * as Yup from 'yup';

import { errorHelper, Loader } from '../../../utils/tools';
import { Button, Form, Row, Col } from 'react-bootstrap';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { sk } from 'date-fns/locale';

const MonthlyIncomeGenerator = ({branchId, evidenceListId, onClose}) => {

    const dispatch = useDispatch();

    const today = new Date();
  
    const year = useSelector((state) => state.uiSlice.selectedYear);

    const currentEvidenceListId = evidenceListId;
    const wasteCodes = useSelector(state => state.wasteCodes.data);
    const warehouses = useSelector(state => state.branch.warehouse);
    const containers = useSelector(state => state.branch.container)
    const currentBranch = branchId;

    const handleSubmit = (values, resetForm) => {
        values.currentEvidenceListId = currentEvidenceListId;

        if(currentBranch !== '') {
            values.branchId = currentBranch;
        }

        dispatch(generateMonthlyIncome(values)).then(() => {
            resetForm();
            if (evidenceListId && branchId) {
                dispatch(showWaste({ evidenceListId, branchId, page:1, limit:25, year, quarter:0 }));
                onClose();
            }
        })
        .catch(error => {
            console.error("Error generating monthly waste:", error);
        });
    }

    const formik = useFormik({
        currentEvidenceListId,
        initialValues: {
            fromDate: new Date(today.getFullYear(), 0, 1),
            date: new Date(),
            warehouse: '',
            container: '',
            weight: 0,
        },
        validationSchema: Yup.object({
            fromDate: Yup.date()
                .required('Prosím vyberte dátum od.'),
            date: Yup.date()
                .min(Yup.ref('fromDate'), 'Dátum do musí byť rovnaký alebo neskorší ako dátum od.')
                .required('Prosím vyberte dátum do.'),
            weight: Yup.number()
                .min(0, 'Číslo musí byť väčšie alebo rovné 0')
                .moreThan(0, 'Hodnota musí byť väčšia ako 0')
                .max(9999, 'Maximálny príjem je 9999.')
                .required('Prosím vyplňte konečnú váhu.'),
        }),

        onSubmit: (values, { resetForm }) => {
            handleSubmit(values, resetForm);
        }
    });

    return (
        <>
            <div className='auth_container'>
                <h2>Vygeneruj vznik mesačne</h2>
                <hr />

                {/* If state users.loading is true showLoader, or show Box */}
                {  wasteCodes.loading ?
                    <Loader/>
                : 
                    <Form
                        component="form"
                        onSubmit={formik.handleSubmit}
                        style={{ display: 'flex', flexDirection: 'column', height: '80vh' }}
                        id="monthlyIncomeGeneratorForm"
                    >

                        <Row>

                            <Col xs={12} sm={12} md={12} lg={12}>
                                {/* From Date */}
                                <Form.Group className="mb-3" controlId="fromDate">
                                    <Form.Label>Dátum od*</Form.Label>
                                    <div className="datepicker-container">
                                        <DatePicker
                                            id="fromDate"
                                            name="fromDate"
                                            showIcon
                                            toggleCalendarOnIconClick
                                            selectsStart
                                            startDate={formik.values.fromDate}
                                            endDate={formik.values.date}
                                            maxDate={formik.values.date || today}
                                            selected={formik.values.fromDate}
                                            onChange={(fromDate) => formik.setFieldValue('fromDate', fromDate)}
                                            dateFormat="dd.MM.yyyy"
                                            className={`form-control ${errorHelper(formik, 'fromDate').error ? 'is-invalid' : ''}`}
                                            locale={sk}
                                            />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'fromDate').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col xs={12} sm={12} md={12} lg={12}>
                                {/* Date */}
                                <Form.Group className="mb-3" controlId="date">
                                    <Form.Label>Dátum do*</Form.Label>
                                    <div className="datepicker-container">
                                        <DatePicker
                                            id="date"
                                            name="date"
                                            showIcon
                                            toggleCalendarOnIconClick
                                            selectsEnd
                                            startDate={formik.values.fromDate}
                                            endDate={formik.values.date}
                                            minDate={formik.values.fromDate}
                                            maxDate={today}
                                            selected={formik.values.date}
                                            onChange={(date) => formik.setFieldValue('date', date)}
                                            dateFormat="dd.MM.yyyy" // Príklad formátu dátumu, môžete prispôsobiť podľa potreby
                                            className={`form-control ${errorHelper(formik, 'date').error ? 'is-invalid' : ''}`}
                                            locale={sk}
                                            />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'date').helperText} {/* Zobrazenie chybovej správy podľa helperText hodnoty z errorHelper */}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                             <Col xs={12} sm={12} md={12} lg={12}>
                                {/* Warehouse */}
                                <Form.Group className="mb-3" controlId="formBasicWarehouse">
                                    <Form.Label>Sklad</Form.Label>
                                    <Form.Select
                                        aria-label="Sklad:"
                                        {...formik.getFieldProps('warehouse')}
                                        isInvalid={errorHelper(formik, 'warehouse').error}
                                    >
                                    <option value="" disabled>
                                        Vyberte sklad:
                                    </option>
    
    
                                    { warehouses.map((warehouse, index) => (
                                        <option key={index} value={warehouse}>
                                            {warehouse}
                                        </option>
                                    ))}
    
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'warehouse').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
    
                            <Col xs={12} sm={12} md={12} lg={12}>
                                {/* Container */}
                                <Form.Group className="mb-3" controlId="formBasicContainer">
                                    <Form.Label>Nádoba</Form.Label>
                                    <Form.Select
                                        aria-label="Nádoba:"
                                        {...formik.getFieldProps('container')}
                                        isInvalid={errorHelper(formik, 'container').error}
                                    >
                                    <option value="" disabled>
                                        Vyberte nádobu:
                                    </option>
    
    
                                    { containers.map((container, index) => (
                                        <option key={index} value={container}>
                                            {container}
                                        </option>
                                    ))}
    
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'container').helperText} {/* Zobrazenie chybovej správy podľa helperText hodnoty z errorHelper */}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col xs={12} sm={12} md={12} lg={12}>
                                {/* Weight */}
                                <Form.Group className="mb-3" controlId="formBasicWeight">
                                    <Form.Label>Konečná váha, ktorá bude rozdelená do mesiacov (t)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Váha:"
                                        className="no-spinner"
                                        onWheel={(e) => e.target.blur()} // Zruší scrollovanie
                                        {...formik.getFieldProps('weight')}
                                        isInvalid={errorHelper(formik, 'weight').error}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'weight').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <hr />
                            <Col className="d-flex justify-content-end">
                                <Button 
                                    className='button-custom-large' 
                                    variant='primary' 
                                    type="submit" 
                                    size="lg" 
                                    style={{ marginTop: 'auto' }}
                                >
                                    Vygeneruj vznik/príjem
                                </Button>
                            </Col>
                        </Row>

                    </Form>
                }
            </div>
        </>
    )
}

export default MonthlyIncomeGenerator;